// extracted by mini-css-extract-plugin
module.exports = {"grid":"Layout_grid__XzBmV","left":"Layout_left__2dMsg"};